import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // Import router
import store from "./store"; // Import your Vuex store
import { formatName } from "./services/util"; // Import the utility function
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Import global CSS
import "./assets/css/style.css"; // Adjust the path if necessary
import "./assets/css/responsive.css"; // Adjust the path if necessary
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Import Bootstrap JS (includes necessary popper.js)
import "intl-tel-input/build/css/intlTelInput.css";

import VueGoogleMaps from "@fawmi/vue-google-maps";

import { formatHospitalCurrency } from "@/utils/currency.js";

// Create the Vue app instance
const app = createApp(App);

// Function to commit the window width to Vuex store
const commitWindowWidth = () =>
  store.commit("dom/SET_WINDOW_WIDTH", window.innerWidth);

// Use the router and store in the app
app.use(router);
app.use(store);
app.use(VueGoogleMaps, {
  load: {
    key: "YOUR_GOOGLE_MAPS_API_KEY",
    libraries: "places",
  },
});
// Handle lifecycle hooks for window resize
app.mount("#app");

// Mounted hook to commit the initial window width
app.config.globalProperties.$mounted = () => {
  commitWindowWidth(); // Commit the current window width
  window.addEventListener("resize", commitWindowWidth); // Add the resize event listener
};

// BeforeUnmount hook to remove the event listener when the app is destroyed
app.config.globalProperties.$beforeUnmount = () => {
  window.removeEventListener("resize", commitWindowWidth); // Remove the resize event listener
};

// Add the `formatName` function globally
app.config.globalProperties.$formatName = formatName;

// Global hospital-based currency formatter
app.config.globalProperties.$formatHospitalCurrency = (amount, hospitalId) => {
  return formatHospitalCurrency(amount, hospitalId);
};
